import Header from "../Components/Header/Header";
import BreathingBox from "../Components/BreathBox/BreathingBox";
import Footer from "../Components/Footer/Footer";
const Breath = () =>{
    return(
        <div className="common-bg">
            <div className="container">
                <Header title ="" />
                    <BreathingBox />
                <Footer />
            </div>
        </div>
    );
}  
export default Breath;